import React, { useContext, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LogoWithoutBeta from "assets/LogoWithoutBeta.svg";
import HamburgerMenu from "assets/Icons/login/HamburgerMenu.svg";
import { useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store/types";
import { toggleNav } from "store/auth/auth.slice";
import { Grid } from "@mui/material";
import { useIntl } from "react-intl";
import I18nKey from "translations/I18nKey";
import LandingPageLogin from "pages/LandingPageLogin";
import Popover from "components/Popover";
import classNames from "classnames";
import useLandingPageHeaderStyles from "./styles";
import AppBar from "../../components/AppBar/index";
import Drawer from "../../components/Drawer/index";
import CommonList from "components/SimpleList";
import { TourContext } from "contexts/TourContext";
import { ScrollOptions } from "./types";
const LandingPageHeader = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const theme = useTheme();
  const intl = useIntl();
  const dispatch = useDispatch();
  const classes = useLandingPageHeaderStyles();
  const { nav } = useSelector((state: AppState) => state.auth);
  const [open, setOpen] = React.useState(false);
  const [collapseInventoryFeatures, setCollapseInventoryFeatures] =
    React.useState<boolean>(true);
  const [active, setActive] = React.useState<string>("");
  const { scrollTo, setScrollTo } = useContext(TourContext);
  const { token } = useSelector((state: AppState) => state.auth);
  useEffect(() => {
    setOpen(nav);
  }, [nav]);
  useEffect(() => {
    setOpen(false);
  }, [isMobile]);

  const handleDrawerToggle = () => {
    dispatch(toggleNav(!nav));
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleSetActive = (index: string) => {
    setActive(index);
  };

  const handleToggleInventoryFeatures = () =>
    setCollapseInventoryFeatures(!collapseInventoryFeatures);

  return (
    <>
      <Box className={classNames(classes.appBarBox)}>
        <AppBar
          className={classNames(classes.appBar, {
            mobile: isMobile && token,
          })}
          open={open}
        >
          <Toolbar
            className={classNames(classes.toolBar, {
              mobile: isMobile,
            })}
          >
            <Grid
              container
              alignItems="center"
              className={classNames(classes.mainGrid, {
                mobile: isMobile,
              })}
            >
              <Grid item className={classNames(classes.menuLogoHolder)}>
                <Grid container alignItems="center">
                  {isMobile ? (
                    <img
                      src={HamburgerMenu}
                      alt="menu"
                      className={classNames(classes.menu)}
                      onClick={handleDrawerToggle}
                    />
                  ) : null}
                  <Box>
                    <img
                      src={LogoWithoutBeta}
                      alt="logo"
                      className={classNames(classes.logo)}
                    />
                  </Box>
                </Grid>
                {isMobile ? null : (
                  <Grid item className={classNames(classes.gridList)}>
                    <CommonList
                      items={[
                        {
                          primary: intl.formatMessage({
                            id: I18nKey.LANDING_PAGE_HEADER_DEMO_VIDEO,
                          }),

                          onClick: () => {
                            setScrollTo(ScrollOptions.DEMO_VIDEO);
                          },
                          classNameText: classNames(
                            classes.listItemTextChinese
                          ),
                          className: classNames(classes.demoVideo),
                        },
                        {
                          primary: intl.formatMessage({
                            id: I18nKey.LANDING_PAGE_HEADER_FEATURES,
                          }),
                          onClick: handleToggleInventoryFeatures,
                          open: !collapseInventoryFeatures,
                          className: classNames(classes.featuresButton),
                          classNameText: classNames(
                            classes.listItemTextChinese
                          ),
                          collapseClassName: classNames(classes.collapse),
                          children: [
                            {
                              primary: intl.formatMessage({
                                id: I18nKey.LANDING_PAGE_HEADER_IMPROVE_CATALOG_HEALTH,
                              }),
                              onClick: () => {
                                setActive(ScrollOptions.CATALOG_HEALTH),
                                  setScrollTo(ScrollOptions.CATALOG_HEALTH);
                              },

                              classNameButtonCollapse: classNames({
                                [classes.mainPageCollapse]:
                                  active === ScrollOptions.CATALOG_HEALTH,
                              }),
                            },
                            {
                              primary: intl.formatMessage({
                                id: I18nKey.LANDING_PAGE_HEADER_STREAMLINE_SUPPLY_CHAIN,
                              }),
                              onClick: () => {
                                setActive(
                                  ScrollOptions.STREAMLINE_SUPPLY_CHAIN
                                ),
                                  setScrollTo(ScrollOptions.SUPPLY_CHAIN);
                              },

                              classNameButtonCollapse: classNames({
                                [classes.mainPageCollapse]:
                                  active ===
                                  ScrollOptions.STREAMLINE_SUPPLY_CHAIN,
                              }),
                            },
                            {
                              primary: intl.formatMessage({
                                id: I18nKey.LANDING_PAGE_HEADER_BUSSINESS_GROWTH,
                              }),
                              onClick: () => {
                                setActive(
                                  ScrollOptions.MANAGE_BUSSINESS_GROWTH
                                ),
                                  setScrollTo(ScrollOptions.BUSSINESS_GROWTH);
                              },

                              classNameButtonCollapse: classNames({
                                [classes.mainPageCollapse]:
                                  active ===
                                  ScrollOptions.MANAGE_BUSSINESS_GROWTH,
                              }),
                            },
                            {
                              primary: intl.formatMessage({
                                id: I18nKey.LANDING_PAGE_HEADER_SELLER_ACCOUNTS,
                              }),
                              onClick: () => {
                                setActive(ScrollOptions.LINK_SELLER_ACCOUNTS);
                                setScrollTo(ScrollOptions.SELLER_ACCOUNTS);
                              },
                              classNameButtonCollapse: classNames({
                                [classes.mainPageCollapse]:
                                  active === ScrollOptions.LINK_SELLER_ACCOUNTS,
                              }),
                            },
                          ],
                        },
                        {
                          primary: intl.formatMessage({
                            id: I18nKey.LANDING_PAGE_HEADER_PRICING,
                          }),
                          onClick: () => {
                            setScrollTo(ScrollOptions.PRICING_PLAN);
                          },
                          classNameText: classNames(
                            classes.listItemTextChinese
                          ),
                          className: classNames(classes.pricing),
                        },
                      ]}
                      className={classNames(classes.list)}
                      expandLogoClassName={classNames(classes.expandLogo)}
                      collapseBoxClassName={classNames(classes.expandLogoBox)}
                    />
                  </Grid>
                )}
              </Grid>

              {isMobile ? null : (
                <Grid item>
                  <LandingPageLogin />
                </Grid>
              )}
            </Grid>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          open={open}
          className={classNames({
            [classes.drawerClose]: !open,
            [classes.drawerOpen]: open,
          })}
        >
          <Box className={classNames(classes.drawerIcon)}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </Box>
          <CommonList
            items={[
              {
                primary: intl.formatMessage({
                  id: I18nKey.LANDING_PAGE_HEADER_FEATURES,
                }),
                onClick: handleToggleInventoryFeatures,
                open: !collapseInventoryFeatures,
                classNameText: classNames(classes.listItemText, {
                  [classes.listItemTextOpen]: open,
                }),
                className: classNames(classes.listItemHeaders, {
                  [classes.listItemBackground]: active === "Features",
                  [classes.listItemFilter]: active === "Features",
                }),
                classNameListItem: classNames(classes.listDrawer),
                children: [
                  {
                    primary: intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_HEADER_IMPROVE_CATALOG_HEALTH,
                    }),
                    onClick: () => {
                      setActive(ScrollOptions.CATALOG_HEALTH);
                      setScrollTo(ScrollOptions.CATALOG_HEALTH);
                      handleDrawerClose();
                    },

                    classNameTextCollapse: classNames(
                      classes.listItemTextCollapse,
                      {
                        [classes.listItemTextCollapseActive]:
                          active === ScrollOptions.CATALOG_HEALTH,
                      }
                    ),
                    classNameButtonCollapse: classNames(
                      classes.listItemButtonCollapse,
                      {
                        [classes.listItemButtonCollapseActive]:
                          active === ScrollOptions.CATALOG_HEALTH,
                      }
                    ),
                  },
                  {
                    primary: intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_HEADER_STREAMLINE_SUPPLY_CHAIN,
                    }),
                    onClick: () => {
                      setActive(ScrollOptions.STREAMLINE_SUPPLY_CHAIN),
                        setScrollTo(ScrollOptions.SUPPLY_CHAIN);
                      handleDrawerClose();
                    },

                    classNameTextCollapse: classNames(
                      classes.listItemTextCollapse,
                      {
                        [classes.listItemTextCollapseActive]:
                          active === ScrollOptions.STREAMLINE_SUPPLY_CHAIN,
                      }
                    ),
                    classNameButtonCollapse: classNames(
                      classes.listItemButtonCollapse,
                      {
                        [classes.listItemButtonCollapseActive]:
                          active === ScrollOptions.STREAMLINE_SUPPLY_CHAIN,
                      }
                    ),
                  },
                  {
                    primary: intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_HEADER_BUSSINESS_GROWTH,
                    }),
                    onClick: () => {
                      setActive(ScrollOptions.MANAGE_BUSSINESS_GROWTH),
                        setScrollTo(ScrollOptions.BUSSINESS_GROWTH);
                      handleDrawerClose();
                    },

                    classNameTextCollapse: classNames(
                      classes.listItemTextCollapse,
                      {
                        [classes.listItemTextCollapseActive]:
                          active === ScrollOptions.MANAGE_BUSSINESS_GROWTH,
                      }
                    ),
                    classNameButtonCollapse: classNames(
                      classes.listItemButtonCollapse,
                      {
                        [classes.listItemButtonCollapseActive]:
                          active === ScrollOptions.MANAGE_BUSSINESS_GROWTH,
                      }
                    ),
                  },
                  {
                    primary: intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_HEADER_SELLER_ACCOUNTS,
                    }),
                    onClick: () => {
                      setActive(ScrollOptions.LINK_SELLER_ACCOUNTS);
                      setScrollTo(ScrollOptions.SELLER_ACCOUNTS);
                      handleDrawerClose();
                    },

                    classNameTextCollapse: classNames(
                      classes.listItemTextCollapse,
                      {
                        [classes.listItemTextCollapseActive]:
                          active === ScrollOptions.LINK_SELLER_ACCOUNTS,
                      }
                    ),
                    classNameButtonCollapse: classNames(
                      classes.listItemButtonCollapse,
                      {
                        [classes.listItemButtonCollapseActive]:
                          active === ScrollOptions.LINK_SELLER_ACCOUNTS,
                      }
                    ),
                  },
                ],
              },
              {
                primary: intl.formatMessage({
                  id: I18nKey.LANDING_PAGE_HEADER_DEMO,
                }),
                onClick: () => {
                  handleSetActive(ScrollOptions.DEMO);
                  setActive(ScrollOptions.DEMO);
                  setScrollTo(ScrollOptions.DEMO_VIDEO);
                  handleDrawerClose();
                },
                classNameText: classNames(classes.listItemText, {
                  [classes.listItemTextOpen]: open,
                }),
                className: classNames(classes.listItemHeaders, {
                  [classes.listItemBackground]: active === "Demo",
                  [classes.listItemFilter]: active === "Demo",
                }),
              },
              {
                primary: intl.formatMessage({
                  id: I18nKey.LANDING_PAGE_HEADER_PRICING,
                }),
                onClick: () => {
                  handleSetActive(ScrollOptions.DASHBOARD);
                  setActive(ScrollOptions.DASHBOARD);
                  setScrollTo(ScrollOptions.PRICING_PLAN);
                  handleDrawerClose();
                },
                classNameText: classNames(classes.listItemText, {
                  [classes.listItemTextOpen]: open,
                }),
                className: classNames(classes.listItemHeaders, {
                  [classes.listItemBackground]: active === "dashboard",
                  [classes.listItemFilter]: active === "dashboard",
                }),
              },
            ]}
            className={classNames(classes.drawerList)}
            expandLogoClassName={classNames(classes.expandLogo)}
            collapseBoxClassName={classNames(classes.expandLogoBox)}
            childrencomponents={<LandingPageLogin />}
          />
          <Divider />
        </Drawer>
        <Popover />
      </Box>
    </>
  );
};
export default LandingPageHeader;
